<p-dialog
  [(visible)]="visible"
  [showHeader]="false"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  styleClass="dialog-wave-redesign"
  [style]="{ width: '450px', height: 'auto' }"
  (visibleChange)="visibleChange.emit($event)">

  <!-- HEADER CUSTOMIZADO COM WAVE -->
  <div class="dialog-wave-header dialog-wave-header--info">
    <div class="dialog-wave-header-content">
      <div class="dialog-wave-icon-container">
        <i class="pi pi-th-large" aria-hidden="true"></i>
      </div>
      <div class="dialog-wave-header-text">
        <h2>{{ texts.titulo }}</h2>
        <p>{{ texts.subtitulo }}</p>
      </div>
    </div>
    <div class="dialog-wave-decorative-circle circle-1" aria-hidden="true"></div>
    <div class="dialog-wave-decorative-circle circle-2" aria-hidden="true"></div>
    <svg class="dialog-wave-svg" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
      <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="white"/>
    </svg>
  </div>

  <!-- CORPO DO DIALOG -->
  <div class="dialog-wave-body">
    <!-- Nome da subcategoria (obrigatorio) -->
    <div class="field">
      <label for="nomeSubcategoria">{{ texts.labels_nome }} *</label>
      <input
        id="nomeSubcategoria"
        type="text"
        pInputText
        [(ngModel)]="nome"
        [placeholder]="texts.placeholders_nome_da_subcategoria"
        style="width: 100%;" />
    </div>

    <!-- Categorias (multi-select, obrigatorio) -->
    <div class="field">
      <label for="categoriaSubcategoria">{{ texts.labels_categorias }} *</label>
      <p-multiSelect
        inputId="categoriaSubcategoria"
        [options]="opcoesGrupos"
        [(ngModel)]="gruposSelecionados"
        optionLabel="label"
        optionValue="value"
        [placeholder]="texts.placeholders_selecione_categorias"
        [disabled]="carregandoGrupos"
        [showClear]="true"
        appendTo="body"
        panelStyleClass="dropdown-panel-above-modal"
        styleClass="w-full">
      </p-multiSelect>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <button pButton class="p-button-secondary" (click)="fechar()" [disabled]="salvando">
      {{ texts.botoes_fechar }} (Esc)
    </button>
    <button pButton (click)="submit()" [disabled]="salvando">
      <i *ngIf="salvando" class="pi pi-spin pi-spinner mr-2"></i>
      {{ texts.botoes_guardar }}
    </button>
  </ng-template>
</p-dialog>
